import React from 'react';
import { Button, Form, } from 'reactstrap';
import { mapValues } from 'lodash';
import { useToggle } from 'react-use';

import { fieldsToSignIn as fields } from '../../shared/models/user';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import PasswordResetFormModal from '../modals/PasswordResetFormModal';
import EmailRecoveryFormModal from '../modals/EmailRecoveryFormModal';
import TenantLink from '../TenantLink';

const { entries } = Object;

export default function SignInForm(props) {
  const { isOpen, values, translate = _ => _, } = props;
  const [showsPasswordResetFormModal, togglePasswordResetFormModal] = useToggle();
  const [showsEmailRecoveryFormModal, toggleEmailRecoveryFormModal] = useToggle();
  const statedFields = useFormState(values, fields, isOpen);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const onSubmit = (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;
    props.onSubmit({ ...mapValues(statedFields, 'value') });
  };

  return (
    <Form onSubmit={onSubmit}>
      <div>
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <Field
              translate={translate}
              key={fieldName}
              name={fieldName}
              {...fieldSetting}
            />
          ))
        }
      </div>
      <div>
        <Button block type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>ログイン</Button>
      </div>
      <div className="text-muted mt-2">
        パスワードをお忘れの方は
        <span className="cursor-pointer text-tlink" onClick={togglePasswordResetFormModal}>
          こちら
        </span>
      </div>
      <div className="text-muted mt-2">
        メールアドレスをお忘れの方は
        <span className="cursor-pointer text-tlink" onClick={toggleEmailRecoveryFormModal}>
          こちら
        </span>
      </div>
      {showsPasswordResetFormModal && <PasswordResetFormModal isOpen onClickClose={togglePasswordResetFormModal} />}
      {showsEmailRecoveryFormModal && <EmailRecoveryFormModal isOpen onClickClose={toggleEmailRecoveryFormModal} />}
    </Form>
  );
};
